import { HFlow, ModalFooter, ModalFooterButton } from 'bold-ui'

interface RequisicaoExameModalFooterProps {
  onClose: () => void
  onSubmit: () => void
  isLastStep: boolean
}

export function RequisicaoExameModalFooter(props: Readonly<RequisicaoExameModalFooterProps>) {
  const { onClose, onSubmit, isLastStep } = props

  return (
    <ModalFooter>
      <HFlow alignItems='center' justifyContent='flex-end'>
        <ModalFooterButton onClick={onClose}>Cancelar</ModalFooterButton>
        <ModalFooterButton kind='primary' onClick={onSubmit}>
          {isLastStep ? 'Salvar' : 'Continuar'}
        </ModalFooterButton>
      </HFlow>
    </ModalFooter>
  )
}
